import { IErrorResult } from '@/types/dto';
import { AxiosError } from 'axios';
import pageOpen from './pageOpen';

export default function getErrorMessage(error: AxiosError<IErrorResult> | string): string {
  if (!error) return '';

  let message = '';
  if (typeof error === 'string') {
    message = error;
  } else if (error.response) {
    if (error.response.status === 404 || error.response.status === 405) {
      message = 'API 地址不存在';
    } else if (error.response.status === 401) {
      message = '您的账号登录已过期或失效，请重新登录';
      pageOpen('/login');
    } else {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      message = error.response.data.message;
    }
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error(error);
    message = error.message;
  }

  return message;
}
